import React from "react"
import PropTypes from "prop-types"

export default class FormView extends React.Component {
  static propTypes = {
    // form: PropTypes.node.isRequired,
    initialValues: PropTypes.func,
    submit: PropTypes.func,
    success: PropTypes.node
  }

  static defaultProps = {
    // initialValues: () => {},
    submit: values => null,
    success: null
  }

  constructor(props) {
    super(props)
    const { initialValues, submit, ...rest } = props
    this.state = {
      values: initialValues ? initialValues() : {},
      // values: {},
      error: false,
      isPending: false,
      isModified: false,
      hasSucceeded: false
    }
    this.submit = submit
    this.formProps = rest
  }

  onChange = (event, data) => {
    const name = event.target.name || (data && data.name)
    const value = event.target.value || (data && data.value) || ""

    this.setState({
      values: {
        ...this.state.values,
        [name]: value
      },
      isModified: true
    })
  }

  onSubmit = event => {
    event.preventDefault()
    if (!this.state.isModified) {
      this.setState({ hasSucceeded: true })
    } else {
      this.setState({ isPending: true })
      Promise.resolve(this.props.submit(this.state.values)).then(
        () => {
          // fulfilled
          this.setState({
            isPending: false,
            hasSucceeded: true
            // isModified: false
          })
        },
        error => {
          // rejected
          this.setState({
            isPending: false,
            hasSucceeded: false
          })
          this.handleError(error)
        }
      )
    }
  }

  handleError = ({ message, fields = {} }) => {
    this.setState({ error: { message, fields } })
  }

  render() {
    const Form = this.props.form
    if (this.state.hasSucceeded) {
      return this.props.success
    } else {
      return (
        <Form
          values={this.state.values}
          error={this.state.error}
          isModified={this.state.isModified}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          isPending={this.state.isPending}
          {...this.formProps}
        />
      )
    }
  }
}
